import * as axios from "axios";
import { getAuthHeader } from "./../utils";

const BASE_URL = process.env.REACT_APP_BASE_URL;

/* ============================
   CREATE CAMPUS DRIVE
============================ */
export const createCampusDrive = (data) => {
    const url = `${BASE_URL}/admin/add-campus-drive`;
    return axios
        .post(url, data, getAuthHeader())
        .then((res) => res.data);
};

/* ============================
   UPDATE CAMPUS DRIVE
============================ */
export const updateCampusDrive = (data) => {
    const url = `${BASE_URL}/admin/edit-campus-drive`;
    return axios
        .put(url, data, getAuthHeader())
        .then((res) => res.data);
};

/* ============================
   GET CAMPUS DRIVE BY ID
============================ */
export const campusDriveById = (id) => {
    const url = `${BASE_URL}/admin/campus-drive-detail/${id}`;
    return axios
        .get(url, getAuthHeader())
        .then((res) => res.data);
};

/* ============================
   LIST CAMPUS DRIVES (PAGINATION)
============================ */
export const campusDriveList = (params) => {
    const url = `${BASE_URL}/admin/campus-drive-list`;
    return axios
        .get(url, {
            ...getAuthHeader(),
            params
        })
        .then((res) => res.data);
};

/* ============================
   UPDATE CAMPUS DRIVE STATUS
============================ */
export const updateCampusDriveStatus = (data) => {
    const url = `${BASE_URL}/admin/update-campus-drive-status`;
    return axios
        .put(url, data, getAuthHeader())
        .then((res) => res.data);
};


export const collegeDropDown = () => {
    const url = `${BASE_URL}/admin/campus-drive/college-drop-down`;
    return axios
        .get(url, {
            ...getAuthHeader()
        })
        .then((res) => res.data);
};